import { render, staticRenderFns } from "./VersionLabelDialog.vue?vue&type=template&id=6e140e12&scoped=true"
import script from "./VersionLabelDialog.vue?vue&type=script&lang=ts"
export * from "./VersionLabelDialog.vue?vue&type=script&lang=ts"
import style0 from "./VersionLabelDialog.vue?vue&type=style&index=0&id=6e140e12&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e140e12",
  null
  
)

export default component.exports